var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 48,
    viewBox: "0 0 60 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.5 12C57.9375 12 60 14.0625 60 16.5V34.5C60 37.0312 57.9375 39 55.5 39H39V34.5H55.5V16.5H25.5V18H21V16.5C21 14.0625 22.9688 12 25.5 12H55.5ZM10.5 4.5V18H6V4.5C6 2.0625 7.96875 0 10.5 0H40.5C42.9375 0 45 2.0625 45 4.5V9H40.5V4.5H10.5ZM31.5 21C33.9375 21 36 23.0625 36 25.5V43.5C36 46.0312 33.9375 48 31.5 48H4.5C1.96875 48 0 46.0312 0 43.5V25.5C0 23.0625 1.96875 21 4.5 21H31.5ZM31.5 43.5V32.25C30.0938 33.2812 24 37.7812 24 37.7812C22.5938 38.8125 20.3438 40.5 18 40.5C15.5625 40.5 13.3125 38.8125 12 37.7812C12 37.7812 5.8125 33.2812 4.5 32.25V43.5H31.5ZM31.5 26.8125V25.5H4.5V26.5312C4.6875 26.625 14.7188 34.125 15 34.4062C15.8438 35.0625 17.0625 36 18 36C18.6562 36 19.6875 35.3438 20.4375 34.875C21 34.5 31.2188 27 31.5 26.8125ZM46.5 19.5H52.5V25.5H46.5V19.5Z",
    fill: "#193154"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageGroup);
export default __webpack_public_path__ + "static/media/message_group.c4f7240c24b0b7df1760825016f8caa5.svg";
export { ForwardRef as ReactComponent };